// extracted by mini-css-extract-plugin
export default {"quota-and-upload":"eWkcoQUR6ZMxGGHtg36z","info-flex":"vDjj2vTRNwnAYPHgJrij"};